import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetKeywordsUsedByOrganisation(organisation, limit) {
  return useAxios({
    cache: { ignoreCache: true },
    url: `/api/v1/keywords/organisation/${encodeURIComponent(organisation)}`,
    method: 'GET',
    params: {
      top: limit,
      search_query_id: window.Livewire?.request?.searchQuery?.id,
    },
  }, { manual: true });
}
